import reframe from 'nike-re-framejs';

reframe.regSub('homepage/stories/data', db => db.getIn(['homepage', 'stories', 'data']));

reframe.regSub('homepage/stories/is-loading', db => !db.getIn(['homepage', 'stories', 'data']));
